import { specialistService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    specialist: null,
    updating: false,
    apps: {
        list: [],
        status: status.INITIAL
    },
    statuses: {
      list: [],
      status: status.INITIAL
    },
    groups: {
        list: [],
        status: status.INITIAL
    },
    specs: {
        list: [],
        status: status.INITIAL
    },

    types: {
        list: [],
        status: status.INITIAL
    },

    currentSpec: null,

    selectedStatus: null,
    selectedType: null,
    selectedModerStatus: null,

    period: null,

    currentApp: null
  },
  getters: {
    specialist: ({ specialist }) => specialist,
    specialistType: ({ specialist }) => specialist && specialist.specialistType,

    statuses: ({ statuses }) => statuses.list,
    isStatusesLoaded: ({ statuses }) => statuses.status == status.LOADED,

    apps: ({ apps }) => apps.list,
    isAppsLoaded: ({ apps }) => apps.status == status.LOADED,

    groups: ({ groups }) => groups.list,
    isGroupsLoaded: ({ groups }) => groups.status == status.LOADED,

    specs: ({ specs }) => specs.list,
    isSpecsLoaded: ({ specs }) => specs.status == status.LOADED,

    types: ({ types }) => types.list,
    isTypesLoaded: ({ types }) => types.status == status.LOADED,

    currentApp: ({ currentApp }) => currentApp,
    isAppLoaded: ({ currentApp }) => currentApp != null,

    currentSpec: ({ currentSpec }) => currentSpec,

    SPECIALIST_FULLNAME: state => {
      if (state.specialist) {
        return state.specialist.persona.name
      }
      return ''
    },
  },
  mutations: {
    setAuthSpecialist: (state, payload) => {
      state.specialist = payload
    },

    setUpdating: (state, value) => {
      state.updating = value
    },
    setCurrentApp: (state, payload) => {
      state.currentApp = payload
    },
    setApps: ({ apps }, payload) => {
      apps.list = payload
    },
    setAppsStatus: ({ apps }, status) => {
      apps.status = status
    },

    editAppItem: (state, advocatAppItem) => {
      if(state.currentApp!=null) { 
        let curr = state.currentApp.advocatAppItems.filter(item => item.id == advocatAppItem.id)[0]
        Object.assign(curr, advocatAppItem)
      }
    },

    setStatuses: ({ statuses }, payload) => {
      statuses.list = payload
    },
    setStatusesStatus: ({ statuses }, status) => {
      statuses.status = status
    },
    selectStatus: (state, payload) => {
      state.selectedStatus = payload
    },

    selectModerStatus: (state, payload) => {
      state.selectedModerStatus = payload
    },

    setGroups: ({ groups }, payload) => {
      groups.list = payload
    },
    setGroupsStatus: ({ groups }, status) => {
      groups.status = status
    },
    addGroup: (state, group) => {
        state.groups.list.push(group)
    },
    editGroup: (state, group) => {
      if(state.groups!=null) { 
        let curr = state.groups.list.filter(item => item.id == group.id)[0]
        Object.assign(curr, group)
      }
    },

    setSpecs: ({ specs }, payload) => {
      specs.list = payload
    },
    setSpecsStatus: ({ specs }, status) => {
      specs.status = status
    },
    setSpec: (state, payload) => {
      state.currentSpec = payload
    },
    approveSpec: (state, spec) => {
      if(state.specs!=null) { 
        let curr = state.specs.list.filter(item => item.id == spec.id)[0]
        Object.assign(curr, spec)
      }
    },


    setTypes: ({ types }, payload) => {
      types.list = payload
    },
    setTypesStatus: ({ types }, status) => {
      types.status = status
    },
    selectType: (state, payload) => {
      state.selectedType = payload
    },

    setPeriod: (state, payload) => {
      state.period = payload
    }
  },
  actions: {
    INIT: ({ dispatch }, { defaultStatus }) => {
        dispatch('GET_STATUSES', defaultStatus)
        dispatch('LOAD_APPS')
    },
    INIT_ITEM: ({ dispatch }, { appId }) => {
        dispatch('LOAD_APP', { appId })
    },
    GET_STATUSES: ({ state, commit }, defaultStatus) => {
        if(state.statuses.status == status.INITIAL ){
           commit('setStatusesStatus', status.LOADING)
           specialistService.appStatuses().then(data => {
             commit('setStatuses', data)
             commit('setStatusesStatus', status.LOADED)
             commit('selectStatus', data.filter(item => item.name === defaultStatus)[0])
           })
        }
    },
    LOAD_APPS_V1: ({ state, commit }) => {
        if(state.apps.status == status.INITIAL ){
           commit('setAppsStatus', status.LOADING)
           specialistService.staffApps().then(data => {
               commit('setApps', data)
               commit('setAppsStatus', status.LOADED)
           })
        }
    },
    LOAD_APPS: ({ commit }) => {
        commit('setAppsStatus', status.LOADING)
        specialistService.staffApps().then(data => {
            commit('setApps', data)
            commit('setAppsStatus', status.LOADED)
        })
    },
    LOAD_APP: ({ state, commit }, { appId }) => {
        if (state.CurrentApp!=null && state.currentApp.id != appId) {
          commit('setCurrentApp', null)
        }
        specialistService.staffApp(appId)
        .then(data => {
          commit('setCurrentApp', data)
        })
    },
    CONFIRM_APP: ({ commit }, { appId }) => {
        return specialistService.confirmApp(appId)
        .then(data => {
          commit('setCurrentApp', data)
          commit('setAppsStatus', status.INITIAL)
        })
    },
    SAVE_APP_ITEM: ({ commit }, payload) => {
        return specialistService.saveAppItem( payload )
        .then(data => { 
          commit('setCurrentApp', data)
          commit('setAppsStatus', status.INITIAL)
        })
    },
    LOAD_GROUPS: ({ state, commit }) => {
        if(state.groups.status == status.INITIAL ){
           commit('setGroupsStatus', status.LOADING)
           specialistService.groups().then(data => {
               commit('setGroups', data)
               commit('setGroupsStatus', status.LOADED)
           })
        }
    },
    CREATE_GROUP: ({ commit }, payload) => {
        specialistService.groupCreate( payload ).then(data => {
            commit('addGroup', data)
        })
    },
    UPDATE_GROUP: ({ commit }, payload) => {
        specialistService.groupUpdate( payload ).then(data => {
            commit('editGroup', data)
        })
    },
    LOAD_SPECS: ({ state, commit }) => {
        if(state.specs.status == status.INITIAL ){
           commit('setSpecsStatus', status.LOADING)
           specialistService.specs().then(data => {
               commit('setSpecs', data)
               commit('setSpecsStatus', status.LOADED)

               let typeList=[] 
               data.forEach(d => {
                 typeList.find(j => j.value === d.specialistType.value) ? null : typeList.push(d.specialistType)
               })
               commit('setTypes', typeList)
               commit('setTypesStatus', status.LOADED)

           })
        }
    },
    LOAD_AUTH_SPEC: ({state, commit }) => {
        if(state.specialist == null ){
           return specialistService.getAuthSpecialist().then(data => {
               commit('setAuthSpecialist', data)
               return data
           })
        } else
           return state.specialist 
    },
    LOAD_CURRENT_SPEC: ({state, commit }) => {
        if(state.specialist == null ){
           return specialistService.getAuthSpecialist().then(data => {
               commit('setSpec', data)
               return data
           })
        } else {
           commit('setSpec', state.specialist)
           return state.specialist 
        }
    },
    LOAD_SPEC: ({ commit }, { specId }) => {
        return specialistService.getProfileById( specId ).then(data => {
            commit('setSpec', data)
        })
    },
    CREATE_SPEC: (context, payload) => {
        return specialistService.specCreate( payload )
    },
    EDIT_SPEC: ({ commit }, payload) => {
        return specialistService.editSpecialist( payload ).then(data => {
            commit('setSpec', data)
        })
    },
    UPDATE_PROFILE: ({ commit }, payload) => {
        return specialistService.editProfile( payload ).then(data => {
            commit('setSpec', data)
            commit('setAuthSpecialist', data)
        })
    },
    APPROVE_SPEC: ({ commit }, { specId }) => {
        return specialistService.specApprove( specId ).then(data => {
            commit('approveSpec', data)
            return data
        })

    },
  }
}